import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { createPersonalLineupQueryOptions } from './queryOptions';
import { PersonalLineupQueryData } from './types';

type FetchPersonalLineupQueryArgs = {
  listType: number;
};

export function fetchPersonalLineupQuery({ listType }: FetchPersonalLineupQueryArgs) {
  return queryClient.fetchQuery(createPersonalLineupQueryOptions({ listType }));
}

export function prefetchPersonalLineupQuery({ listType }: FetchPersonalLineupQueryArgs) {
  return queryClient.prefetchQuery(createPersonalLineupQueryOptions({ listType }));
}

export function getPersonalLineupQueryData() {
  return queryClient.getQueryData<PersonalLineupQueryData>(queryKeys.personalLineup);
}
